<template>
	<v-container fluid class="ma-0 pa-0">
    <v-col class="ma-0 pa-0" cols="12">
			<DashboardHeader />
			<v-col class="pa-3 pt-8" id="main_content_maxwidthset" cols="12">
				<CCTVStatusBox />
				<v-col class="ma-0 pa-5 mb-7" cols="12" id="cctv_player_box"
					v-if="authorities.GET_RECORDING_SUB_BRANCH">
					<v-row class="ma-0 pa-0 pl-4 pr-4 mb-2" align="center" justify="space-between">
						<v-col class="ma-0 pa-0" cols="auto" style="font-weight:bold;">
							{{td('cameraList')}}</v-col>
						<v-row class="ma-0 pa-0" align="center" justify="end">
							<v-col class="ma-0 pa-0 pr-2" cols="3">
								<v-select class="ma-0 pa-1" v-model="selectedPriority"
									:items="priorityList" dense hide-details outlined
									dark item-text="label" item-value="value"
								></v-select>
							</v-col>
						</v-row>
					</v-row>
					<VideoThumbnailBox :priority="selectedPriority" />
				</v-col>
			</v-col>
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import DashboardHeader from './Header.vue';
import CCTVStatusBox from './CCTVStatusBox.vue';
import VideoThumbnailBox from './VideoThumbnailBox.vue';
import rtcViewer from '@/api/webrtc';
import { VideoErrorStatus } from '@/constants';
export default {
	components: {
		DashboardHeader, CCTVStatusBox, VideoThumbnailBox
	},
	mixins: [mixin.common],
	data: () => ({
		authorities: {},
		selectedPriority: 3,
	}),
	computed: {
		priorityList() {
			return [
				{ label: this.$i18n.t('lang.dashboard.priorityValue0'), value: 0 }, // 시청자순
				// { label: 'モーション検出', value: 1 },
				// { label: 'サウンド検出', value: 2 },
				{ label: this.$i18n.t('lang.dashboard.priorityValue3'), value: 3 }, // 카메라이름 오름차순
				{ label: this.$i18n.t('lang.dashboard.priorityValue4'), value: 4 }, // 카메라이름 내림차순
				{ label: this.$i18n.t('lang.dashboard.priorityValue5'), value: 5 }, // 등록순 오름
				{ label: this.$i18n.t('lang.dashboard.priorityValue6'), value: 6 }, // 등록순 내림
			];
		}
	},
	created() {
		this.authorities = this.$store.getters.getAuthorities;
  },
	mounted() {
    this.checkCameraAuthResult();
		console.group('%cUser Data', "font-size:14px;color:#008DD0;");
    // console.log(JSON.parse(sessionStorage.getItem('auth')));
    console.log('%cUser Detail\n', "color:#008DD0;", this.$store.state.userData.user);
    console.log('%cAuthorities\n', "color:#008DD0;", this.$store.getters.getAuthorities);
    console.log('%cStore Group Label\n', "color:#008DD0;", this.$store.state.userData.storeGroupLabel);
    console.log('%cStore Group List\n', "color:#008DD0;", this.$store.state.userData.storeGroupList);
    console.groupEnd();
    this.$store.commit('player/SET_PLAYER_ALL_VALUE_DEFAULT');
    setTimeout(() => rtcViewer.removeRTCRemnants(), 1000);
	},
	methods: {
		td(t) {
      return this.$t("lang.dashboard." + t);
    },
	}
} 
</script>

<style lang="scss" scoped>
#cctv_player_box {
	background-color: #34363C;
	// border: 1px solid #707070;
	color: white;
	border-radius: 5px;
	min-height: 10rem;
}
.v-list{
  background: #171921 !important;
	border: 1px solid #4A4A4A;
}
::v-deep {
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		background: #272727;
	}
	.v-list-item__content{
		color: white;
	}
	.v-input__slot {
		padding-right: 2px !important;
	}
	.v-input__append-inner {
		margin-top: 16px !important;
		padding-left: 0px !important;
	}
	// Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 35px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
</style>